import { render } from "./Founder.vue?vue&type=template&id=5b4463e6&scoped=true"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"

import "./Founder.vue?vue&type=style&index=0&id=5b4463e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4463e6"]])

export default __exports__